var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUploadBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 878"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 349",
    style: {
      fill: "none"
    },
    d: "M0 0h96v96H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 879"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 363",
    d: "M60.222 48.175v12.047h-48.19V48.175H4v12.047a8.055 8.055 0 0 0 8.032 8.032h48.19a8.055 8.055 0 0 0 8.032-8.032V48.175zm-44.175-24.1 5.662 5.662 10.4-10.361V52.19h8.032V19.381l10.4 10.361 5.662-5.662L36.127 4z",
    transform: "translate(11.682 11.682)",
    style: {
      fill: "#6c969d"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadBlack24Dp);
export default __webpack_public_path__ + "static/media/file_upload_black_24dp.cec70696eeb64f994517e3962f88222a.svg";
export { ForwardRef as ReactComponent };